<template>
    <div class="page-container">
    <dialog :open="dialog" class="mfa-popup-main-div select-popup-main-div">
    <div class="titleSectionHeader">
        <span class="titleSectionHeaderTitleSpan">
            <h1 class="titleSectionHeaderTitle">{{$t( "helptopics.hklongmanloginpage.helptextheader")}}</h1>
        </span>
        <h1 id="headerTitleSR" class="sr-only"></h1>
        <a class="iconWrapper mfa-icon-btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24px" height="24px">
                <path
                    d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
        </a>
        <a class="back-button back-button-login-page">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256"
                height="256" viewBox="0 0 256 256" xml:space="preserve">
                <defs>
                </defs>
                <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                    transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                    <path
                        d="M 65.75 90 c 0.896 0 1.792 -0.342 2.475 -1.025 c 1.367 -1.366 1.367 -3.583 0 -4.949 L 29.2 45 L 68.225 5.975 c 1.367 -1.367 1.367 -3.583 0 -4.95 c -1.367 -1.366 -3.583 -1.366 -4.95 0 l -41.5 41.5 c -1.367 1.366 -1.367 3.583 0 4.949 l 41.5 41.5 C 63.958 89.658 64.854 90 65.75 90 z"
                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                </g>
            </svg>
            <h1>{{$t( "helptopics.hklongmanloginpage.helptextheader1")}}</h1>
        </a>
        <hr>
    </div>
        <ul class="contentSection" id="popupListItem">
        <li tabindex="0" role="link" data-id="1">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ1")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextA1")}}</div>
        </li>
        <li tabindex="0" role="link" data-id="2">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ2")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextA2")}}</div>
        </li>
        <li tabindex="0" role="link" data-id="3">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ3")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextA3")}}</div>
        </li>
        <li tabindex="0" role="link" data-id="4">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ4")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextA4")}}</div>
        </li>
        <li class="details" data-parent="1">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ1")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD1")}}</div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD1A1")}}</div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD1A2")}}</div>
           </li>
        <li class="details" data-parent="2">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ2")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD2")}}</div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD2A1")}}</div>
        </li>
        <li class="details" data-parent="3">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ3")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD3")}}</div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD3A1")}}</div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD3A2")}}</div>
        </li>
        <li class="details" data-parent="4">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ4")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD4")}}
              <a :href="helpSupportLink" target="_blank">{{$t( "helptopics.hklongmanloginpage.helptextD4L")}}</a>
              {{$t( "helptopics.hklongmanloginpage.helptextD4A1")}}</div>
        </li>
        <li class="details" data-parent="5">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextQ5")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextD5")}}</div>
        </li>
    </ul>
    </dialog>
        <div class="logo-div-container">
            <div>
                <div class="logo-container">
                    <img class="main-logo side-logo" :src="pearsonLogoUrl()" width="212px" alt="Pearson logo" />
                </div>
                <div class="logo-text">
                    <span>{{this.$t('pages.selfservice.registration.welcomeText')}}</span>
                </div>
            </div>
        </div>
        <fr-center-card :class="['pearson-card', { 'email-validation-card': isEmailValidationStage }]" :showLogo="false">
          <div slot="center-card-header">
            <div style='text-align: end;' v-if="hklongman || certprep || skillingPartner" ><b-img :src="require('@/assets/images/pearson_help.png')" rounded="circle" width="22" height="22" alt="img" @click="showDialog" id="help_icon_login" :title="$t('helptopics.hklongmanloginpage.helptextMsg')" /></div>
                <h2 class="h2">{{ isEmailValidationStage ? this.$t('pages.selfservice.registration.checkEmailTitle') : (poaClient ? this.$t('pages.selfservice.registration.registerParentAccount') : this.$t('pages.selfservice.registration.registerYourAccount')) }}</h2>
                <span v-show="!isError && !isEmailValidationStage" class="center-card-sign-in">{{ this.$t('pages.selfservice.registration.haveAccount') }} <a id="loginUrl" class="login-url" v-if="!hasTokenQueryParam" @click="backUrl">{{ this.$t('pages.selfservice.registration.signIn') }}</a></span>
            </div>
            <b-card-body slot="center-card-body">
                    <component ref="selfServiceStage" v-show="showSelfService"
                               :is="selfServiceType"
                               :selfServiceDetails="selfServiceDetails"
                               :registeredEmail="registeredEmail"
                               @advanceStage="onAdvanceStage">
                    </component>
                    <div v-if="isEmailValidationStage" class="email-validation-back-link">
                        <a id="registration-back-to-sign-in" class="email-validation-back-link__anchor" @click="backUrl">{{ $t('pages.selfservice.passwordReset.returnToSignInAnchorText') }}</a>
                    </div>
                </b-card-body>
        </fr-center-card>
    </div>
    <!-- <div class="h-100">
        <b-container fluid class="h-100 px-0" v-show="!showSelfService">
            <div class="h-100 d-flex">
                <div class="m-auto fr-center-card">
                    <bounce-loader :color="loadingColor"></bounce-loader>
                </div>
            </div>
        </b-container>

        <div v-show="showSelfService">
            <fr-center-card :showLogo="true" v-if="selfServiceType !== 'localAutoLogin'">
                <div slot="center-card-header">
                    <p style='font-weight: 400;font-size: 24px;' class='subtitle'>{{this.$t('pages.selfservice.registration.registerYourAccount')}}</p>
                </div>

                <b-card-body slot="center-card-body">
                    <component ref="selfServiceStage" v-show="showSelfService"
                               :is="selfServiceType"
                               :selfServiceDetails="selfServiceDetails"
                               @advanceStage="advanceStage">
                    </component>
                </b-card-body>
            </fr-center-card>
        </div>
    </div> -->
</template>

<script>
import _ from 'lodash';
import { BounceLoader } from 'vue-spinner/dist/vue-spinner.min.js';
import styles from '@/scss/theme-variables.scss';
import CenterCard from '@/components/utils/CenterCard';
import AllInOneRegistration from '@/components/selfservice/registration/AllInOneRegistration';
import Captcha from '@/components/selfservice/common/Captcha';
import Consent from '@/components/selfservice/registration/Consent';
import emailValidation from '@/components/selfservice/registration/EmailValidation';
import GenericSelfService from '@/components/selfservice/common/GenericSelfService';
import idmUserDetails from '@/components/selfservice/registration/UserDetails';
import kbaSecurityAnswerDefinitionStage from '@/components/selfservice/registration/KBASecurityAnswerDefinitionStage.vue';
import SelfserviceAPI from '@/components/selfservice/mixins/SelfserviceAPIMixin';
import TermsAndConditions from '@/components/selfservice/registration/TermsAndConditions';
// import LanguagePicker from '@/components/LanguagePicker.vue';
import $ from 'jquery';
// import { MANDATORY_CONSENTS } from '../../../utils/common';
import { getClientById, CLIENT } from '../../../lib/getClientById';
import { getParams } from '../../../lib/URLUtils';
import { getSpringBootHost } from '../../../lib/springBootHosts';

const customTitleComponents = [
    'captcha',
    'consent',
    'emailValidation',
    'kbaSecurityAnswerDefinitionStage',
    'termsAndConditions'
];

/**
 * @description Selfservice controlling component for registering a resource (e.g. a new user). Makes use of selfservice-registration.json config file.
 *
 * @mixin - selfservice/mixins/SelfserviceAPIMixin.vue
 *
 * @fires POST authentication?_action=login - Uses localAutoLogin stage that sets a JWT after a successful registration to start a user session.
 * Alternatively if registration came through social, login will use the data store token to go forward with login after a successful registration.
 * @fires POST authentication?_action=logout - Ends current user session
 */
export default {
    name: 'Registration',
    components: {
        'fr-center-card': CenterCard,
        AllInOneRegistration,
        BounceLoader,
        Captcha,
        Consent,
        emailValidation,
        idmUserDetails,
        kbaSecurityAnswerDefinitionStage,
        TermsAndConditions,
        GenericSelfService
    },
    props: ['clientToken'],
    mixins: [
        SelfserviceAPI
    ],
    data () {
        return {
            selfServiceType: null,
            selfServiceDetails: null,
            registeredEmail: '',
            loadingColor: styles.baseColor,
            showSelfService: false,
            apiType: 'registration',
            clientTokenUsed: false,
            input: {},
            token: null,
            isError: false,
            dialog: false,
            hklongman: getClientById() === CLIENT.HK_LONGMAN,
            certprep: getClientById() === CLIENT.CERT_PREP,
            skillingPartner: getClientById() === CLIENT.SKILLING_PARTNER,
            revibe: getClientById() === CLIENT.REVIBE,
            poaClient: getClientById() === CLIENT.POA_CLIENT
        };
    },
    computed: {
        title () {
            if (_.includes(customTitleComponents, this.selfServiceType)) {
                return this.$t(`pages.selfservice.registration.stageTitle.${this.selfServiceType}`);
            } else {
                return this.$t('pages.selfservice.registration.registerYourAccount');
            }
        },
        subtitle () {
            if (_.includes(customTitleComponents, this.selfServiceType)) {
                return this.$t(`pages.selfservice.registration.stageSubtitle.${this.selfServiceType}`);
            } else {
                return this.$t('pages.selfservice.registration.signUpMsg');
            }
        },
        hasTokenQueryParam () {
            const searchParams = new URLSearchParams(window.location.search);
            return searchParams.has('token');
        },
        isEmailValidationStage () {
            return this.selfServiceType === 'emailValidation';
        },
        helpSupportLink () {
            if (this.hklongman) {
                return this.$t('helptopics.hklongmanloginpage.helptextSupportLink');
            } else {
                return 'https://support.pearson.com/getsupport/s/';
            }
        }
    },
    mounted () {
        const hash = window.location.hash.substring(1);
        const firstAmp = hash.indexOf('&');
        if (this.$route.params.queryParams && firstAmp !== -1) {
            /* istanbul ignore next */
            // queryParams come from the link emailed to the user for the emailValidation stage
            // This stops the flicker by hiding everything in the center-card
            this.selfServiceType = 'localAutoLogin';
            let queryParams = this.parseQueryParams(hash.substring(firstAmp));
            this.advanceStage(queryParams);
        } else {
            this.loadData();
        }
        $('#help_icon_login').off('click').on('click', function (event) {
            $('.mfa-popup-main-div').toggleClass('slideIn').show();
        });
        $('.mfa-icon-btn').click(function () {
            $('.mfa-popup-main-div').removeClass('slideIn');
            $('.mfa-popup-main-div').hide();
        });
        $('#popupListItem li:not(.details)').click(function () {
            var id = $(this).data('id');
            $('#popupListItem li:not([data-parent="' + id + '"])').hide();
            $('#popupListItem li[data-parent="' + id + '"]').show();
            $('.back-button').show();
            $('.titleSectionHeaderTitle').hide();
        });
        $('.back-button').click(function () {
            $('#popupListItem li').show();
            $('.details').hide();
            $('.back-button').hide();
            $('.titleSectionHeaderTitle').show();
        });
    },
    methods: {
        onAdvanceStage (data, noSessionFalse) {
            const email = data?.user?.mail || data?.mail;
            if (email) {
                this.registeredEmail = email;
            }
            this.advanceStage(data, noSessionFalse);
        },
        getLocaleFromUrl () {
            return new URLSearchParams(window.location.search).get('locale');
        },
        backUrl (event) {
            if (!this.$route.query.token) {
                event.preventDefault();
                let goto;
                const queryParams = getParams();
                const goToParam = queryParams.get('goto');
                const pageLang = this.getLocaleFromUrl() || this.$i18n.locale;
                if (goToParam) {
                    try {
                        const gotoUrl = new URL(goToParam);
                        if (gotoUrl.searchParams.get('locale') !== pageLang) {
                            gotoUrl.searchParams.set('locale', pageLang);
                        }
                        const relayState = gotoUrl.searchParams.get('RelayState');
                        if (relayState) {
                            try {
                                const relayStateObj = new URL(relayState);
                                const lang = relayStateObj.searchParams.get('lang');
                                if (lang && lang !== pageLang) {
                                    relayStateObj.searchParams.set('lang', pageLang);
                                    gotoUrl.searchParams.set('RelayState', relayStateObj.toString());
                                }
                            } catch (e) {
                                console.error('Error parsing RelayState:', e);
                            }
                        }
                        goto = gotoUrl.toString();
                    } catch (_) {
                        goto = goToParam;
                    }
                }
                if (goto) {
                    window.location.assign(goto);
                } else {
                    window.location.assign(window.location.origin + '/auth/XUI/?realm=/pearson&service=AuthN#login/');
                }
            }
        },
        showDialog () {
            this.dialog = true;
        },
        getQueryStringValue (name) {
            let url = decodeURIComponent(window.location.href);
            name = name.replace(/[[]/, '\\["').replace(/[\]]/, '\\]');
            let regexS = '[\\?&]' + name + '=([^&#]*)';
            let regex = new RegExp(regexS);
            let results = regex.exec(url);
            return results == null ? null : results[1];
        },
        pearsonLogoUrl () {
            var realm;
            var clientId = getClientById();
            if (clientId === CLIENT.REVIBE) {
                return require('@/assets/images/Revibe-logo.png');
            }
            if (this.$route.query.realm === undefined && localStorage.realm === undefined) {
                localStorage.realm = 'PEARSON';
                realm = 'PEARSON';
            } else if (this.$route.query.realm !== undefined) {
                localStorage.realm = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
                realm = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
            } else if (localStorage.realm !== undefined) {
                realm = localStorage.realm;
            }
            if (realm === 'PEARSONCOLLEGELONDON') {
                return require('@/assets/images/pcl_white.png');
            } else {
                return require('@/assets/images/PearsonLogo_Horizontal_Blk_RGB.png');
            }
        },
        setChildComponent (type, details) {
            this.selfServiceDetails = details;

            if (type === 'parameters') {
                this.selfServiceType = null;
                this.showSelfService = false;

                this.advanceStage({
                    'input': {}
                });
            } else if (this.clientToken && !this.clientTokenUsed) {
                this.advanceStage({
                    'clientToken': this.clientToken,
                    'oauthRegister': 'true'
                });
                this.clientTokenUsed = true;
            } else if (details.type === 'localAutoLogin') {
                if (_.has(details, 'additions.oauthLogin') && details.additions.oauthLogin) {
                    /* istanbul ignore next */
                    const socialLoginInstance = this.getRequestService({
                        headers: {
                            'X-OpenIDM-NoSession': 'false',
                            'X-OpenIDM-OAuth-Login': 'true',
                            'X-OpenIDM-DataStoreToken': this.clientToken,
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    });

                    /* istanbul ignore next */
                    socialLoginInstance.post('/authentication?_action=login')
                        .then((userDetails) => {
                            this.displayNotification('success', this.$t('pages.selfservice.registration.createdAccount'));

                            if (details.additions.successUrl && details.additions.successUrl.length > 0) {
                                window.location = details.additions.successUrl;
                            } else {
                                this.progressiveProfileCheck(userDetails, () => {
                                    window.history.pushState('', '', window.location.pathname);
                                    this.$router.push('/');
                                });
                            }
                        })
                        .catch(() => {
                            window.history.pushState('', '', window.location.pathname);
                            this.$router.push('/login');
                        });
                } else {
                    this.$router.push(`/success?locale=${this.$i18n.locale}`);
                    // this.autoLogin(details.additions.credentialJwt, details.additions.successUrl);
                }
            } else if (type === 'localAutoRedirect') {
                if (details.additions?.successUrl) {
                    if (this.poaClient) {
                        const springBootHost = getSpringBootHost(location.hostname);
                        const regionEndpoint = `${springBootHost}/v1/identity/lookup/region/user/${details.additions?.username}`;
                        fetch(regionEndpoint, {
                            method: 'GET',
                            credentials: 'include'
                        })
                            .then((regionResp) => {
                                if (!regionResp.ok) {
                                    console.error(`Region lookup fetch failed with status ${regionResp.status}`);
                                }
                                _.forEach(details?.additions, (value, key) => {
                                    if (key.includes('SSOSession') && value) {
                                        document.cookie = `${key}=${value}; domain=.pearson.com; path=/; SameSite=None; Secure;`;
                                    }
                                });
                                window.location.href = details?.additions?.successUrl;
                            })
                            .catch((error) => {
                                console.error('Error during region lookup fetch:', error);
                                _.forEach(details?.additions, (value, key) => {
                                    if (key.includes('SSOSession') && value) {
                                        document.cookie = `${key}=${value}; domain=.pearson.com; path=/; SameSite=None; Secure;`;
                                    }
                                });
                                window.location.href = details?.additions?.successUrl;
                            });
                    } else {
                        const successUrl = new URL(details.additions.successUrl);
                        if (!successUrl.searchParams.has('locale')) {
                            successUrl.searchParams.append('locale', this.$i18n.locale);
                        }
                        this.$router.push({
                            path: '/success',
                            query: {
                                goto: successUrl.toString(),
                                locale: this.$i18n.locale
                            }
                        });
                    }
                } else {
                    this.$router.push(`/success?locale=${this.$i18n.locale}`);
                }
            } else if (type === 'openAMAutoLogin' && details.status) {
                if (_.has(details, 'additions.successUrl')) {
                    // If there is a provided success url then follow it.
                    /* istanbul ignore next */
                    window.location.href = details.additions.successUrl;
                } else {
                    // Otherwise, redirect to login and send success notification.
                    this.$router.push('/login');
                    /* istanbul ignore next */
                    this.displayNotification('success', this.$t('pages.selfservice.registration.createdAccount'));
                }
            } else if (type === 'localAutoRedirect') {
                if (details.additions?.successUrl) {
                    if (this.poaClient) {
                        _.forEach(details?.additions, (value, key) => {
                            if (key.includes('SSOSession') && value) {
                                document.cookie = `${key}=${value}; domain=.pearson.com; path=/; SameSite=None; Secure;`;
                            }
                        });

                        window.location.href = details?.additions?.successUrl;
                    } else {
                        const successUrl = new URL(details.additions.successUrl);
                        if (!successUrl.searchParams.has('locale')) {
                            successUrl.searchParams.append('locale', this.$i18n.locale);
                        }
                        this.$router.push({
                            path: '/success',
                            query: {
                                goto: successUrl.toString(),
                                locale: this.$i18n.locale
                            }
                        });
                    }
                } else {
                    this.$router.push(`/success?locale=${this.$i18n.locale}`);
                }
            } else {
                let stageCheck = false;

                _.each(this.$options.components, (value, key) => {
                    if (_.toLower(key) === _.toLower(type)) {
                        stageCheck = true;
                    }
                });

                if (stageCheck) {
                    this.selfServiceType = type;
                } else {
                    this.selfServiceType = 'GenericSelfService';
                }

                this.showSelfService = true;
            }
        },
        apiErrorCallback (error) {
            // let errorMessage;
            if (error.response === undefined) {
                this.$router.push(`/success?locale=${this.$i18n.locale}`);
            } else {
                // this.$router.push('/success');
                // errorMessage = this.findPolicyError(error.response);
                // this.displayNotification('error', errorMessage);
                if (typeof window.gaEvent === 'function') {
                    window.gaEvent('Register', 'Register', 'Failed', error.response.data.message);
                }
                if (error.response.data.message === 'Invalid code' || error.response.data.message === 'Snapshot token is invalid') {
                    this.isError = true;
                    this.setChildComponent('idmUserDetails', { error: this.$t('pages.selfservice.registration.registerLinkExpired') });
                } else {
                    this.isError = true;
                    this.setChildComponent('idmUserDetails', { error: error.response.data.message });
                }
            }
            this.showSelfService = true;

            // TODO Readd this if it is problematic not resetting all of registration on failure
            // clean up any queryParams from the url
            // this.$router.push('/registration');

            // reload the form
            // this.loadData();
        },
        findPolicyError (errorResponse) {
            let errorMessage = errorResponse.data.message,
                policyError = '';

            if (_.has(errorResponse, 'data.detail.failedPolicyRequirements')) {
                let policy = errorResponse.data.detail.failedPolicyRequirements[0];

                if (policy.policyRequirements.length > 0) {
                    policyError = this.$t(`common.policyValidationMessages.${policy.policyRequirements[0].policyRequirement}`, { property: policy.property });

                    errorMessage = `${errorMessage}: ${policyError}`;
                }
            }

            return errorMessage;
        },
        autoLogin: function (jwt, successUrl) {
            /* istanbul ignore next */
            var loginServiceInstance = this.getRequestService({
                    headers: {
                        'X-OpenIDM-Jwt': jwt,
                        'X-OpenIDM-NoSession': false,
                        'X-OpenIDM-Password': null,
                        'X-OpenIDM-Username': null
                    }
                }),
                idmInstance = this.getRequestService({
                    headers: this.getAnonymousHeaders()
                });

            /* istanbul ignore next */
            idmInstance.post('/authentication?_action=logout').then(() => {
                loginServiceInstance.post('/authentication?_action=login').then((userDetails) => {
                    this.displayNotification('success', this.$t('pages.selfservice.registration.createdAccount'));
                    if (successUrl && successUrl.length > 0) {
                        window.location = successUrl;
                    } else {
                        // Check for progressive profiling.
                        this.progressiveProfileCheck(userDetails, () => {
                            this.$router.push('/');
                        });
                    }
                })
                    .catch((error) => {
                        /* istanbul ignore next */
                        this.displayNotification('error', error.response.data.message);
                    });
            });
        }
    }
};
</script>
<style scoped lang="scss">
@import '../../../scss/pearson-common.css';

.email-validation-card {
    height: 256px;
}

.email-validation-back-link {
    margin-top: 24px;
    line-height: 1.5;
}

.email-validation-back-link a#registration-back-to-sign-in {
    display: block;
    font-weight: 700;
    font-size: 16px;
    color: #595959;
    text-decoration: underline;
    text-decoration-color: #595959;
    margin-left: 0;
    padding-left: 0;
    cursor: pointer;
}

.email-validation-back-link a#registration-back-to-sign-in:hover,
.email-validation-back-link a#registration-back-to-sign-in:focus {
    color: #595959;
    text-decoration: underline;
    text-decoration-color: #595959;
}
</style>
